<template>
  <div id="page" class="pc-page">
    <div class="pc-lan-wrapper">
      <div class="text">LAN</div>
      <el-dropdown class="dop-text">
        {{ nowSite }}
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="(item, index) in siteList"
              :key="index"
              @click="handleClickJump(item)"
              >{{ item.siteCode }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <div class="pc-banner">
      <img
        alt=""
        src="https://oss-de.tineco.com/tineco-cloud/gzpc/1601146317983313922.png "
      />
      <!--      <div class="pc-banner-title font-PF_M">添可支持</div>-->
    </div>
    <div class="pc-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from "element-plus";

export default defineComponent({
  name: "t-page",
  components: {
    ElDropdown,
    ElDropdownItem,
    ElDropdownMenu,
  },
  setup() {
    const store = useStore();
    //站点列表
    const siteList = computed(() => store.state.siteList);
    //当前站点
    const nowSite = computed(() => store.state.siteCode);
    //点击站点跳转
    const handleClickJump = (item) => {
      window.location.href =
        window.location.origin +
        "/troubleshooting-web/product/" +
        item.siteCode;
    };
    return {
      siteList,
      nowSite,
      handleClickJump,
    };
  },
});
</script>

<style lang="less" scoped>
.pc-page {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  position: relative;
  overflow: auto;

  .pc-lan-wrapper {
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
    align-items: center;

    .text {
      width: 60px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0048b9;
      color: #fff;
      font-size: 14px;
      border-radius: 4px 0 0 4px;
    }

    .dop-text {
      width: 40px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      color: #0048b9;
      font-size: 14px;
      border-radius: 0 4px 4px 0;
      cursor: pointer;
    }
  }

  .pc-banner {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }

    .pc-banner-title {
      position: absolute;
      top: calc((38% - 56px) / 2);
      width: 100%;
      font-size: 40px;
      font-weight: 500;
      color: #303133;
      line-height: 56px;
      text-align: center;
    }
  }

  .pc-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    width: 1280px;
    min-height: 513px;
    background: #ffffff;
    z-index: 2;
    margin: -18% auto 50px;
  }
}
</style>
